if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.formId = this.dataset.formId;
        this.sectionId = this.dataset.section;
        this.submitButton = this.querySelector('.sticky-atc__submit');
        this.quantityInput = this.querySelector('.sticky-atc__input');
        this.originalSubmit = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.originalQuantity = document.getElementById(`Quantity-${this.sectionId}`);
        this.syncingQuantity = false;

        if (this.closest('quick-add-modal')) {
          this.setVisible(false);
          return;
        }

        if (!this.originalQuantity && this.quantityInput) {
          this.quantityInput.setAttribute('name', 'quantity');
          this.quantityInput.setAttribute('form', this.formId);
        }

        this.syncQuantityFromOriginal();
        this.syncSubmitFromOriginal();
        this.bindQuantitySync();
        this.bindSubmitObserver();
        this.setVisible(true);

        this.submitButton?.addEventListener('click', () => this.pushQuantityToOriginal());

        if (typeof subscribe === 'function') {
          this.quantityUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, () =>
            this.syncQuantityFromOriginal()
          );
          this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => {
            this.syncQuantityFromOriginal();
            this.syncSubmitFromOriginal();
          });
        }
      }

      disconnectedCallback() {
        this.submitObserver?.disconnect();
        this.quantityUnsubscriber?.();
        this.variantUnsubscriber?.();
      }

      bindQuantitySync() {
        if (this.quantityInput) {
          this.quantityInput.addEventListener('input', () => this.pushQuantityToOriginal());
          this.quantityInput.addEventListener('change', () => this.pushQuantityToOriginal());
        }

        if (this.originalQuantity) {
          this.originalQuantity.addEventListener('input', () => this.pullQuantityFromOriginal());
          this.originalQuantity.addEventListener('change', () => this.pullQuantityFromOriginal());
        }
      }

      copyQuantityAttributes(source, target, includeValue) {
        ['min', 'max', 'step'].forEach((attr) => {
          const value = source.getAttribute(attr);
          if (value !== null) {
            target.setAttribute(attr, value);
          } else {
            target.removeAttribute(attr);
          }
        });
        ['data-min', 'data-max'].forEach((attr) => {
          const value = source.getAttribute(attr);
          if (value !== null) {
            target.setAttribute(attr, value);
          } else {
            target.removeAttribute(attr);
          }
        });
        if (includeValue) target.value = source.value;
      }

      pushQuantityToOriginal() {
        if (this.syncingQuantity || !this.originalQuantity || !this.quantityInput) return;
        this.syncingQuantity = true;
        this.copyQuantityAttributes(this.quantityInput, this.originalQuantity, true);
        this.originalQuantity.closest('quantity-input')?.validateQtyRules();
        this.syncingQuantity = false;
      }

      pullQuantityFromOriginal() {
        if (this.syncingQuantity || !this.originalQuantity || !this.quantityInput) return;
        this.syncingQuantity = true;
        this.copyQuantityAttributes(this.originalQuantity, this.quantityInput, true);
        this.querySelector('quantity-input')?.validateQtyRules();
        this.syncingQuantity = false;
      }

      syncQuantityFromOriginal() {
        this.pullQuantityFromOriginal();
      }

      bindSubmitObserver() {
        if (!this.originalSubmit) return;
        this.submitObserver = new MutationObserver(() => this.syncSubmitFromOriginal());
        this.submitObserver.observe(this.originalSubmit, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          subtree: true,
        });
      }

      syncSubmitFromOriginal() {
        if (!this.originalSubmit || !this.submitButton) return;

        this.submitButton.toggleAttribute('disabled', this.originalSubmit.hasAttribute('disabled'));

        if (this.originalSubmit.getAttribute('aria-disabled') === 'true') {
          this.submitButton.setAttribute('aria-disabled', 'true');
        } else {
          this.submitButton.removeAttribute('aria-disabled');
        }

        const isLoading = this.originalSubmit.classList.contains('loading');
        this.submitButton.classList.toggle('loading', isLoading);

        const spinner = this.submitButton.querySelector('.loading__spinner');
        if (spinner) spinner.classList.toggle('hidden', !isLoading);

        const originalText = this.originalSubmit.querySelector('span');
        const stickyText = this.submitButton.querySelector('[data-sticky-atc-text]');
        if (originalText && stickyText) {
          stickyText.textContent = originalText.textContent.trim();
        }
      }

      setVisible(visible) {
        this.classList.toggle('is-visible', visible);
        this.toggleAttribute('inert', !visible);
        this.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }
    }
  );
}
